import React from "react";
import { Helmet } from "react-helmet";
import Loader from "../../../components/common/Loader";
import Footer from "../../../components/home1/Footer";
import Menu from "../../../components/innerpage/Menu";
import Navbar from "../../../components/home1/Navbar";
import ServiceDetail from "../../../components/innerpage/service_detail/ServiceDetail";
import { SITE_URL, SITE_NAME, DEFAULT_OG_IMAGE } from "../../../seoConfig";

const PAGE_TITLE = "Project Consultation Services | " + SITE_NAME;
const PAGE_DESC =
  "End-to-end project consultation — planning, budget estimation, contractor coordination, site inspections, and construction monitoring to keep your project on time, on budget, and on vision.";
const PAGE_PATH = "/innerpages/services/project-consultation";

function ProjectConsultation() {
  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESC} />
        <meta
          name="keywords"
          content="project consultation, project management, construction monitoring, budget estimation, contractor coordination, site inspection, quality control"
        />
        <link rel="canonical" href={`${SITE_URL}${PAGE_PATH}`} />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESC} />
        <meta property="og:url" content={`${SITE_URL}${PAGE_PATH}`} />
        <meta property="og:image" content={`${SITE_URL}${DEFAULT_OG_IMAGE}`} />
        <meta property="og:site_name" content={SITE_NAME} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={PAGE_DESC} />
        <meta name="twitter:image" content={`${SITE_URL}${DEFAULT_OG_IMAGE}`} />

        <link
          rel="stylesheet"
          type="text/css"
          href="/innerpages/assets/css/innerpages.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/innerpages/assets/css/navbar-fix.css"
        />
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/innerpages/assets/js/innerpages.js"></script>
        <body className="inner-pages-style1 s-project-pg-style1 service-detail-page" />
      </Helmet>
      <Loader />
      <Menu />
      <div className="smooth-scroll-content" id="scrollsmoother-container">
        <Navbar />
        <main>
          <ServiceDetail
            tag="Consultation"
            title="Project Consultation"
            intro="A successful project requires more than great design — it demands careful planning, strategic coordination, and experienced management throughout every stage of execution."
            heroImage="/innerpages/assets/img/services/4.png"
            // TODO: swap these 4 paths for your actual image files
            gallery={[
              "/innerpages/assets/img/services/gallery/consultation-1.jpg",
              "/innerpages/assets/img/services/gallery/consultation-2.jpg",
              "/innerpages/assets/img/services/gallery/consultation-3.jpg",
              "/innerpages/assets/img/services/gallery/consultation-4.jpg",
            ]}
            paragraphs={[
              "Our project consultation services provide clients with professional guidance from the earliest planning phase to the successful completion of construction.",
              "We work closely with architects, contractors, consultants, suppliers, and clients to ensure seamless communication, efficient workflows, and complete transparency. By monitoring progress, managing timelines, controlling budgets, and maintaining quality standards, we help eliminate costly delays and ensure every project remains aligned with its original vision.",
              "Our team provides practical solutions, technical expertise, and continuous support throughout the construction journey. From selecting the right materials and evaluating contractors to conducting site inspections and resolving on-site challenges, we remain actively involved to safeguard both design quality and project efficiency.",
              "Whether you're building a new home, renovating an existing property, or developing a commercial project, our consultation services are designed to simplify the process, reduce uncertainty, and deliver exceptional results with confidence.",
            ]}
            listTitle="Our Project Consultation Services"
            listItems={[
              "Project Planning & Strategy",
              "Budget Estimation & Cost Management",
              "Design Coordination",
              "Site Evaluation & Feasibility Studies",
              "Contractor & Vendor Coordination",
              "Material Procurement Guidance",
              "Construction Monitoring",
              "Quality Control & Site Inspections",
              "Timeline & Progress Management",
              "End-to-End Project Management",
            ]}
            otherServices={[
              {
                title: "Architecture & Exterior Design",
                link: "/innerpages/services/architecture-exterior-design",
              },
              {
                title: "Interior Design",
                link: "/innerpages/services/interior-design",
              },
              {
                title: "Furniture Design",
                link: "/innerpages/services/furniture-design",
              },
            ]}
          />
        </main>
        <Footer />
      </div>
    </>
  );
}

export default ProjectConsultation;
